import { DataItem } from '../dataqueries/dataQuery.types';

export type Column = string[];

const getTableColumnsSingleItem = (item: object): Column[] =>
    Object.entries(item).flatMap(([key, value]) => {
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            return getTableColumnsSingleItem(value).map((subKeys) => [key, ...subKeys]);
        } else {
            return [[key]];
        }
    });

export const getTableColumns = (items: DataItem[]): Column[] => {
    const allColumns: Column[] = [];
    const allColumnsAsString = new Set<string>();
    items.forEach((item) =>
        getTableColumnsSingleItem(item).forEach((column) => {
            if (!allColumnsAsString.has(column.toString())) {
                allColumnsAsString.add(column.toString());
                allColumns.push(column);
            }
        }),
    );
    return allColumns;
};

export const formatColumnHuman = (column: Column) => column.join(' ');

export const getColumnValue = (column: Column, item: DataItem): unknown =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-unsafe-return
    column.reduce((subObject: any, key: string) => (typeof subObject === 'object' ? subObject[key] : undefined), item);
